export function isModalShown(state, id) {
  return state.ui.modals.hasOwnProperty(id) && state.ui.modals[id].shown;
}


export function getModalExtra(state, id) {
  return state.ui.modals.hasOwnProperty(id) && state.ui.modals[id].extra ?
    state.ui.modals[id].extra : {};
}
